import React from "react";
import SectionTitle from "../../components/section-title";
import PropTypes from "prop-types";

const VulnerabilityContainer = ({ contRef, classOption = "section-pb" }) => {
    return (
        <div>
            <div className="container py-5">
                <div className="row justify-content-center">
                    <div className="col-lg-10 col-xl-8">
                        <div className="text-center mb-4">
                            <h2 className="fw-bold text-dark">
                                Report a Vulnerability
                            </h2>
                        </div>
                        <div className="bg-light p-4 rounded shadow-sm">
                            <p className="mb-3 text-muted">
                                We are committed to ensuring the security and
                                integrity of our systems and services. If you
                                believe you have discovered a vulnerability in
                                our software or systems, we encourage you to
                                report it to us responsibly.
                            </p>
                            <p className="mb-3 text-muted">
                                Please contact our Information Security team by
                                emailing{" "}
                                <a
                                    href="mailto:teamciso@neogrowth.in"
                                    className="text-primary fw-semibold"
                                >
                                    teamciso@neogrowth.in
                                </a>{" "}
                                with detailed information about the
                                vulnerability, including steps to reproduce it
                                if possible.
                            </p>
                            <p className="mb-0 text-muted">
                                We appreciate your efforts to help us maintain a
                                secure environment.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

VulnerabilityContainer.propTypes = {
    classOption: PropTypes.string,
    contRef: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
    ]),
};

export default VulnerabilityContainer;
